import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mm",
  "use": "icon-mm-usage",
  "viewBox": "0 0 11 13.2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 13.2\" id=\"icon-mm\"><title>资源 5</title><g id=\"icon-mm_图层_2\" data-name=\"图层 2\"><g id=\"icon-mm_图层_1-2\" data-name=\"图层 1\"><path d=\"M9.5,13.2h-8A1.5,1.5,0,0,1,0,11.7V5.8A1.5,1.5,0,0,1,1.5,4.3h8A1.5,1.5,0,0,1,11,5.8v5.9A1.5,1.5,0,0,1,9.5,13.2Zm-8-7.9a.5.5,0,0,0-.5.5v5.9a.5.5,0,0,0,.5.5h8a.5.5,0,0,0,.5-.5V5.8a.5.5,0,0,0-.5-.5Z\" /><path d=\"M5.5,10.3A.5.5,0,0,1,5,9.8V7.9a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V9.8A.5.5,0,0,1,5.5,10.3Z\" /><path d=\"M8.3,5a.5.5,0,0,1-.5-.5V3.3A2.3,2.3,0,0,0,5.5,1,2.3,2.3,0,0,0,3.2,3.3V4.5a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5V3.3A3.3,3.3,0,0,1,5.5,0,3.3,3.3,0,0,1,8.8,3.3V4.5A.5.5,0,0,1,8.3,5Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/mm.svg
// module id = kdO5
// module chunks = 72